import * as actionTypes from 'actions';

const initialState = {
  pageNumber: 1,
  rowCount: 0,
  loading: false,
  items: [],
  pageSize: 250,
  filterItemCount: null,
  filter: {
    search: ''
  },
  groups: [],
  groupsLoading: false,
  groupsProcessing: false,
  users: []
};

const PAGE = 'SESSION_GROUP_LIST';

const sessionGroupListReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SESSION_GROUPS_PAGINATED_LIST_PENDING: {
      return {
        ...state,
        loading: true
      };
    }

    case actionTypes.SESSION_GROUPS_PAGINATED_LIST_FULFILLED: {
      return {
        ...state,
        ...action.payload.data.result,
        filter: {
          ...initialState.filter,
          ...action.payload.data.result.filter
        },
        loading: false
      };
    }

    case actionTypes.SET_FILTER_VALUE: {
      let result;
      if (action.payload.pageName === PAGE) {
        result = {
          ...state,
          filter: {
            ...state.filter,
            ...action.payload.value
          }
        };
      } else {
        result = {
          ...state
        };
      }

      return result;
    }

    case actionTypes.FIND_SESSION_GROUP_CREATED_BY_USERS_FULFILLED: {
      return {
        ...state,
        users: action.payload.data.result
      };
    }

    case actionTypes.SET_PAGE_SIZE: {
      let result;
      if (action.payload.pageName === PAGE) {
        result = {
          ...state,
          pageSize: action.payload.pageSize
        };
      } else {
        result = {
          ...state
        };
      }

      return result;
    }

    case actionTypes.CLEAR_FILTER_VALUES: {
      let result;
      if (action.payload.pageName === PAGE) {
        result = {
          ...state,
          filter: {
            ...initialState.filter,
            search: state.filter.search
          },
          filterItemCount: initialState.filterItemCount
        };
      } else {
        result = {
          ...state
        };
      }

      return result;
    }

    case actionTypes.GET_FILTER_VALUES_FULFILLED: {
      let result;
      if (
        action.payload.data.result &&
        action.payload.data.result.page === PAGE
      ) {
        result = {
          ...state,
          filterItemCount: action.payload.data.result.filter.filterItemCount,
          filter: {
            ...initialState.filter,
            ...action.payload.data.result.filter
          }
        };
      } else {
        result = {
          ...state
        };
      }

      return result;
    }

    case actionTypes.FIND_SESSION_GROUPS_PENDING: {
      return {
        ...state,
        groupsLoading: true
      };
    }

    case actionTypes.FIND_SESSION_GROUPS_FULFILLED: {
      return {
        ...state,
        groups: action.payload.data.result,
        groupsLoading: false
      };
    }

    case actionTypes.ADD_SESSIONS_TO_GROUP_PENDING: {
      return {
        ...state,
        groupsProcessing: true
      };
    }

    case actionTypes.ADD_SESSIONS_TO_GROUP_FULFILLED: {
      return {
        ...state,
        groupsProcessing: false
      };
    }

    case actionTypes.REMOVE_SESSIONS_FROM_GROUP_PENDING: {
      return {
        ...state,
        groupsProcessing: true
      };
    }

    case actionTypes.REMOVE_SESSIONS_FROM_GROUP_FULFILLED: {
      return {
        ...state,
        groupsProcessing: false
      };
    }

    default: {
      return state;
    }
  }
};

export default sessionGroupListReducer;
